import { type SrcSetObject } from './types'

export * from './sizes'

export const sortSrcSet = (srcSetObject: SrcSetObject): SrcSetObject => {
  return Object.fromEntries(
    Object.entries(srcSetObject).sort(
      ([sizeDescA], [sizeDescB]) =>
        parseInt(sizeDescA, 10) - parseInt(sizeDescB, 10)
    )
  )
}

export const transformSrcSet = (srcSetObject: SrcSetObject): string => {
  return Object.entries(srcSetObject)
    .map(([width, src]) => {
      return `${src} ${width}`
    })
    .join(',')
}
